export default "__VITE_ASSET__qU$ZqKGr__"